import * as tslib_1 from "tslib";
import { Component, Vue, Provide, Prop, Watch, Ref, } from "vue-property-decorator";
import elementResizeDetectorMaker from "element-resize-detector";
const transitionTime = 300; // from CSS
const MutationObserver = Vue.prototype.$isServer
    ? false
    : window.MutationObserver ||
        window.WebKitMutationObserver ||
        window.MozMutationObserver ||
        false;
const findComponentsDownward = (context, componentName, ignoreComponentNames = []) => {
    if (!Array.isArray(ignoreComponentNames)) {
        ignoreComponentNames = [ignoreComponentNames];
    }
    return context.$children.reduce((components, child) => {
        if (child.$options.name === componentName)
            components.push(child);
        if (ignoreComponentNames.indexOf(child.$options.name || "") < 0) {
            const foundChilds = findComponentsDownward(child, componentName);
            return components.concat(foundChilds);
        }
        else {
            return components;
        }
    }, []);
};
const getNextTab = (list, activeKey, direction, countDisabledAlso) => {
    const currentIndex = list.findIndex((tab) => tab.name === activeKey);
    const nextIndex = (currentIndex + direction + list.length) % list.length;
    const nextTab = list[nextIndex];
    if (nextTab.disabled)
        return getNextTab(list, nextTab.name, direction, countDisabledAlso);
    else
        return nextTab;
};
const focusFirst = (element, root) => {
    try {
        element.focus();
    }
    catch (err) { } // eslint-disable-line no-empty
    if (document.activeElement == element && element !== root)
        return true;
    const candidates = element.children;
    for (let candidate of candidates) {
        if (focusFirst(candidate, root))
            return true;
    }
    return false;
};
let RouteTab = class RouteTab extends Vue {
    constructor() {
        super(...arguments);
        this.TabsInstance = this;
        this.navList = [];
        this.barWidth = 0;
        this.barOffset = 0;
        this.activeKey = this.value || "";
        this.focusedKey = this.value || "";
        this.showSlot = false;
        this.navStyle = {
            transform: "",
        };
        this.scrollable = false;
        this.transitioning = false;
        this.observer = elementResizeDetectorMaker();
    }
    get classes() {
        return [
            "ivu-tabs",
            {
                ["ivu-tabs-card"]: this.type === "card",
                ["ivu-tabs-mini"]: this.size === "small" && this.type === "line",
                ["ivu-tabs-no-animation"]: !this.animated,
            },
        ];
    }
    get contentClasses() {
        return [
            "ivu-tabs-content",
            {
                ["ivu-tabs-content-animated"]: this.animated,
            },
            this.custContentClass,
        ];
    }
    get barClasses() {
        return [
            "ivu-tabs-ink-bar",
            {
                ["ivu-tabs-ink-bar-animated"]: this.animated,
            },
        ];
    }
    get contentStyle() {
        const x = this.getTabIndex(this.activeKey);
        const p = x === 0 ? "0%" : `-${x}00%`;
        let style = {};
        if (x > -1) {
            style = {
                transform: `translateX(${p}) translateZ(0px)`,
            };
        }
        const { custContentStyle } = this;
        if (custContentStyle) {
            for (const key in custContentStyle) {
                style[key] = custContentStyle[key];
            }
        }
        return style;
    }
    get barStyle() {
        let style = {
            visibility: "hidden",
            width: `${this.barWidth}px`,
        };
        if (this.type === "line")
            style.visibility = "visible";
        if (this.animated) {
            style.transform = `translate3d(${this.barOffset}px, 0px, 0px)`;
        }
        else {
            style.left = `${this.barOffset}px`;
        }
        return style;
    }
    onValueChange(val) {
        this.activeKey = val;
        this.focusedKey = val;
    }
    onActiveKeyChange(val) {
        this.focusedKey = val;
        this.updateBar();
        this.updateStatus();
        // this.broadcast('Table', 'on-visible-change', true);
        this.$nextTick(() => {
            this.scrollToActiveTab();
        });
        // update visibility
        const nextIndex = Math.max(this.getTabIndex(this.focusedKey), 0);
        this.updateVisibility(nextIndex);
    }
    mounted() {
        this.showSlot = this.$slots.extra !== undefined;
        this.observer.listenTo(this.navWrap, this.handleResize);
        const hiddenParentNode = this.isInsideHiddenElement();
        if (hiddenParentNode && MutationObserver) {
            this.mutationObserver = new MutationObserver(() => {
                if (hiddenParentNode.style.display !== "none") {
                    this.updateBar();
                    this.mutationObserver && this.mutationObserver.disconnect();
                }
            });
            this.mutationObserver &&
                this.mutationObserver.observe(hiddenParentNode, {
                    attributes: true,
                    childList: true,
                    characterData: true,
                    attributeFilter: ["style"],
                });
        }
        this.handleTabKeyboardSelect(true);
        this.updateVisibility(this.getTabIndex(this.activeKey));
    }
    beforeDestroy() {
        this.observer.removeListener(this.navWrap, this.handleResize);
        if (this.mutationObserver)
            this.mutationObserver.disconnect();
    }
    getTabs() {
        // return this.$children.filter(item => item.$options.name === 'TabPane');
        const AllTabPanes = findComponentsDownward(this, "RouteTabPane");
        const TabPanes = [];
        AllTabPanes.forEach((item) => {
            if (item.tab && this.name) {
                if (item.tab === this.name) {
                    TabPanes.push(item);
                }
            }
            else if (this.$children.includes(item)) {
                // #6279 #6299
                TabPanes.push(item);
            }
        });
        // 在 TabPane 使用 v-if 时，并不会按照预先的顺序渲染，这时可设置 index，并从小到大排序
        TabPanes.sort((a, b) => {
            if (a.index && b.index) {
                return a.index > b.index ? 1 : -1;
            }
            return 0;
        });
        return TabPanes;
    }
    updateNav() {
        this.navList = [];
        this.getTabs().forEach((pane, index) => {
            this.navList.push({
                label: pane.label,
                name: pane.currentName || index,
                disabled: pane.disabled,
                closable: pane.closable,
            });
            if (!pane.currentName)
                pane.currentName = index;
            if (index === 0) {
                if (!this.activeKey)
                    this.activeKey = pane.currentName || index;
            }
        });
        this.updateStatus();
        this.updateBar();
    }
    updateBar() {
        this.$nextTick(() => {
            const index = this.getTabIndex(this.activeKey);
            if (!this.nav)
                return; // 页面销毁时，这里会报错，为了解决 #2100
            const prevTabs = this.nav.querySelectorAll(".ivu-tabs-tab");
            const tab = prevTabs[index];
            this.barWidth = tab ? tab.offsetWidth : 0;
            if (index > 0) {
                let offset = 0;
                const gutter = this.size === "small" ? 0 : 16;
                for (let i = 0; i < index; i++) {
                    offset += prevTabs[i].offsetWidth + gutter;
                }
                this.barOffset = offset;
            }
            else {
                this.barOffset = 0;
            }
            this.updateNavScroll();
        });
    }
    updateStatus() {
        const tabs = this.getTabs();
        tabs.forEach((tab) => (tab.show = tab.currentName === this.activeKey || this.animated));
    }
    tabCls(item) {
        return [
            "ivu-tabs-tab",
            {
                ["ivu-tabs-tab-disabled"]: item.disabled,
                ["ivu-tabs-tab-active"]: item.name === this.activeKey,
                ["ivu-tabs-tab-focused"]: item.name === this.focusedKey,
            },
        ];
    }
    handleChange(index) {
        if (this.transitioning)
            return;
        this.transitioning = true;
        setTimeout(() => (this.transitioning = false), transitionTime);
        const nav = this.navList[index];
        if (nav.disabled)
            return;
        this.activeKey = nav.name;
        this.$emit("input", nav.name);
        this.$emit("on-click", nav.name);
    }
    handleTabKeyNavigation(e) {
        if (e.code !== "ArrowLeft" && e.code !== "ArrowRight")
            return;
        const direction = e.code === "ArrowRight" ? 1 : -1;
        const nextTab = getNextTab(this.navList, this.focusedKey, direction);
        this.focusedKey = nextTab.name;
    }
    handleTabKeyboardSelect(init = false) {
        if (init)
            return;
        const focused = this.focusedKey || 0;
        const index = this.getTabIndex(focused);
        this.handleChange(index);
    }
    handleRemove(index) {
        if (!this.beforeRemove) {
            return this.handleRemoveTab(index);
        }
        const before = this.beforeRemove(index);
        if (before && before.then) {
            before.then(() => {
                this.handleRemoveTab(index);
            });
        }
        else {
            this.handleRemoveTab(index);
        }
    }
    handleRemoveTab(index) {
        // eventEmitter.timer = setInterval(()=>{
        //   console.log(Object.keys(eventEmitter.queue))
        //   if(Object.keys(eventEmitter.queue).length !== 0) return;
        //   clearInterval(eventEmitter.timer);
        // },200)
        const tabs = this.getTabs();
        const tab = tabs[index];
        tab.$destroy();
        if (tab.currentName === this.activeKey) {
            const newTabs = this.getTabs();
            let activeKey = -1;
            if (newTabs.length) {
                const leftNoDisabledTabs = tabs.filter((item, itemIndex) => !item.disabled && itemIndex < index);
                const rightNoDisabledTabs = tabs.filter((item, itemIndex) => !item.disabled && itemIndex > index);
                if (rightNoDisabledTabs.length) {
                    activeKey = rightNoDisabledTabs[0].currentName || "";
                }
                else if (leftNoDisabledTabs.length) {
                    activeKey =
                        leftNoDisabledTabs[leftNoDisabledTabs.length - 1].currentName || "";
                }
                else {
                    activeKey = newTabs[0].currentName || "";
                }
            }
            this.activeKey = activeKey;
            this.$emit("input", activeKey);
        }
        this.$emit("on-tab-remove", tab.currentName);
        this.updateNav();
    }
    showClose(item) {
        if (this.type === "card") {
            if (item.closable !== null) {
                return item.closable;
            }
            else {
                return this.closable;
            }
        }
        else {
            return false;
        }
    }
    scrollPrev() {
        const containerWidth = this.navScroll.offsetWidth;
        const currentOffset = this.getCurrentScrollOffset();
        if (!currentOffset)
            return;
        let newOffset = currentOffset > containerWidth ? currentOffset - containerWidth : 0;
        this.setOffset(newOffset);
    }
    scrollNext() {
        const navWidth = this.nav.offsetWidth;
        const containerWidth = this.navScroll.offsetWidth;
        const currentOffset = this.getCurrentScrollOffset();
        if (navWidth - currentOffset <= containerWidth)
            return;
        let newOffset = navWidth - currentOffset > containerWidth * 2
            ? currentOffset + containerWidth
            : navWidth - containerWidth;
        this.setOffset(newOffset);
    }
    getCurrentScrollOffset() {
        const { navStyle } = this;
        return navStyle.transform
            ? Number(navStyle.transform.match(/translateX\(-(\d+(\.\d+)*)px\)/)[1])
            : 0;
    }
    getTabIndex(name) {
        return this.navList.findIndex((nav) => nav.name === name);
    }
    setOffset(value) {
        this.navStyle.transform = `translateX(-${value}px)`;
    }
    scrollToActiveTab() {
        if (!this.scrollable)
            return;
        const nav = this.nav;
        const activeTab = this.$el.querySelector(".ivu-tabs-tab-active");
        if (!activeTab)
            return;
        const navScroll = this.navScroll;
        const activeTabBounding = activeTab.getBoundingClientRect();
        const navScrollBounding = navScroll.getBoundingClientRect();
        const navBounding = nav.getBoundingClientRect();
        const currentOffset = this.getCurrentScrollOffset();
        let newOffset = currentOffset;
        if (navBounding.right < navScrollBounding.right) {
            newOffset = nav.offsetWidth - navScrollBounding.width;
        }
        if (activeTabBounding.left < navScrollBounding.left) {
            newOffset =
                currentOffset - (navScrollBounding.left - activeTabBounding.left);
        }
        else if (activeTabBounding.right > navScrollBounding.right) {
            newOffset =
                currentOffset + activeTabBounding.right - navScrollBounding.right;
        }
        if (currentOffset !== newOffset) {
            this.setOffset(Math.max(newOffset, 0));
        }
    }
    updateNavScroll() {
        const navWidth = this.nav.offsetWidth;
        const containerWidth = this.navScroll.offsetWidth;
        const currentOffset = this.getCurrentScrollOffset();
        if (containerWidth < navWidth) {
            this.scrollable = true;
            if (navWidth - currentOffset < containerWidth) {
                this.setOffset(navWidth - containerWidth);
            }
        }
        else {
            this.scrollable = false;
            if (currentOffset > 0) {
                this.setOffset(0);
            }
        }
    }
    handleResize() {
        this.updateNavScroll();
    }
    isInsideHiddenElement() {
        let parentNode = this.$el.parentNode;
        while (parentNode && parentNode !== document.body) {
            if (parentNode.style &&
                parentNode.style.display === "none") {
                return parentNode;
            }
            parentNode = parentNode.parentNode;
        }
        return false;
    }
    updateVisibility(index) {
        [...this.panes.querySelectorAll(".ivu-tabs-tabpane")].forEach((el, i) => {
            if (index === i) {
                [...el.children]
                    .filter((child) => child.classList.contains("ivu-tabs-tabpane"))
                    .forEach((child) => (child.style.visibility = "visible"));
                if (this.captureFocus)
                    setTimeout(() => focusFirst(el, el), transitionTime);
            }
            else {
                setTimeout(() => {
                    [...el.children]
                        .filter((child) => child.classList.contains("ivu-tabs-tabpane"))
                        .forEach((child) => (child.style.visibility = "hidden"));
                }, transitionTime);
            }
        });
    }
};
tslib_1.__decorate([
    Prop([String, Number])
], RouteTab.prototype, "value", void 0);
tslib_1.__decorate([
    Prop({
        validator(value) {
            return ["line", "card"].includes(value);
        },
        default: "line",
    })
], RouteTab.prototype, "type", void 0);
tslib_1.__decorate([
    Prop({
        validator(value) {
            return ["small", "default"].includes(value);
        },
        default: "default",
    })
], RouteTab.prototype, "size", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean,
        default: true,
    })
], RouteTab.prototype, "animated", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean,
        default: false,
    })
], RouteTab.prototype, "captureFocus", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean,
        default: false,
    })
], RouteTab.prototype, "closable", void 0);
tslib_1.__decorate([
    Prop(Function)
], RouteTab.prototype, "beforeRemove", void 0);
tslib_1.__decorate([
    Prop(String)
], RouteTab.prototype, "name", void 0);
tslib_1.__decorate([
    Prop({
        type: String,
        default: "",
    })
], RouteTab.prototype, "custContentClass", void 0);
tslib_1.__decorate([
    Prop(Object)
], RouteTab.prototype, "custContentStyle", void 0);
tslib_1.__decorate([
    Provide()
], RouteTab.prototype, "TabsInstance", void 0);
tslib_1.__decorate([
    Ref()
], RouteTab.prototype, "navContainer", void 0);
tslib_1.__decorate([
    Ref()
], RouteTab.prototype, "navWrap", void 0);
tslib_1.__decorate([
    Ref()
], RouteTab.prototype, "navScroll", void 0);
tslib_1.__decorate([
    Ref()
], RouteTab.prototype, "nav", void 0);
tslib_1.__decorate([
    Ref()
], RouteTab.prototype, "panes", void 0);
tslib_1.__decorate([
    Watch("value")
], RouteTab.prototype, "onValueChange", null);
tslib_1.__decorate([
    Watch("activeKey")
], RouteTab.prototype, "onActiveKeyChange", null);
RouteTab = tslib_1.__decorate([
    Component({
        name: "RouteTab",
    })
], RouteTab);
export default RouteTab;
